import styled from 'styled-components';
import { IconColumn } from './DataEntryTableColumnDefinitions.styles';

export const ShowOnColumnHover = styled.span`
  display: none;

  ${IconColumn}:hover & {
    display: initial;
  }
`;

export const HideOnColumnHover = styled.span`
  ${IconColumn}:hover & {
    display: none;
  }
`;
